import { GatsbyImage, getImage } from "gatsby-plugin-image"
import React from "react"
import * as styles from "src/styles/project_card.module.scss"
import Card from "./Card"

export default function ProjectCard({ title, image, details }) {
  return (
    <Card>
      <h2 className={styles.card_topic}>{title}</h2>
      <GatsbyImage
        className={styles.card_image}
        image={getImage(image)}
        alt="Project Image"
      />
      <p className={styles.details}>{details}</p>
      <p className={styles.read_more}>
        <strong>Read more...</strong>
      </p>
    </Card>
  )
}
